import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin } from 'antd';
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'
@inject('webEDIStore')
@observer
class WebEDI extends Component {
  render() {
    const { webEDIStore } = this.props
    const { isFetching } = webEDIStore
    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <SearchForm />
          <SearchResult />
        </div>
      </Spin>
    );
  }
}
export default WebEDI;
